import { connect } from 'react-redux'
import { selectGroupsById } from 'selectors/app'
import { selectAgents, selectAgentsById } from 'selectors/agents/base'
import {
  selectFilteredAgentsInAllGroups,
  selectFilteredAgentsInSelectedGroup,
  selectFilteredGroups,
  selectFilteredGroupsFromAgentFilter,
  selectIsFilteringPossibleAssignees,
  selectSelectedAgent,
  selectSelectedGroup,
  selectSelectedGroupAgentsCount,
  selectSuggestedAgents,
  selectTicketAssigning,
} from 'selectors/assignments'
import Menu from 'components/App/DesktopView/shared/AssignmentDropdown'

import { selectRoomIdFromUrl } from 'ducks/chat/selectors/rooms'
import { doAssignRoom } from 'ducks/chat/actions/rooms'

const select = state => ({
  agentsById: selectAgentsById(state),
  allAgents: selectAgents(state),
  filteredAgents: selectFilteredAgentsInSelectedGroup(state),
  filteredAgentsAllGroups: selectFilteredAgentsInAllGroups(state),
  filteredGroups: selectFilteredGroups(state),
  filteredGroupsFromAgentFilter: selectFilteredGroupsFromAgentFilter(state),
  groupsById: selectGroupsById(state),
  isFilteringPossibleAssignees: selectIsFilteringPossibleAssignees(state),
  isOpen: selectTicketAssigning(state),
  selectedAgent: selectSelectedAgent(state),
  selectedGroup: selectSelectedGroup(state),
  selectedGroupAgentsCount: selectSelectedGroupAgentsCount(state),
  suggestedAgents: selectSuggestedAgents(state),
  conversationIds: selectRoomIdFromUrl(state),
})

// The room apis have been standadised completely to always accept
// a roomId and options. In order to meet component specific interface
// we'll simply create these per component mapping functions
// to keep our "core" update functions clean
function assignRoom(conversationId, groupId, agentId, options = {}) {
  return doAssignRoom(conversationId, { teamId: groupId, agentId, ...options })
}

const perform = {
  onGroupSelect: assignRoom,
  onAgentSelect: assignRoom,
}

export default connect(select, perform)(Menu)
